import { CarouselItemId } from '@homex/se-widget-flow-types';

import { SET_ACCELERATED_ENTRY_POINT } from 'actions';

export function setAcceleratedEntryPoint(
  acceleratedEntryPoint: CarouselItemId | null,
) {
  return { acceleratedEntryPoint, type: SET_ACCELERATED_ENTRY_POINT };
}
